
document.addEventListener('DOMContentLoaded', function() {
    const timelineBlocks = document.querySelectorAll('.timeline-scroll__block');
    const viewportHeight = window.innerHeight;
    const centerY = viewportHeight / 2;

    function calculateMaxTabContentHeight() {
        const tabContentBlocks = document.querySelectorAll('.timeline-scroll__block-tab-content');
        let maxHeight = 0;

        tabContentBlocks.forEach(block => {
            const originalDisplay = block.style.display;
            block.style.display = 'block';
            
            const blockHeight = block.offsetHeight;
            if (blockHeight > maxHeight) {
                maxHeight = blockHeight;
            }
            
            block.style.display = originalDisplay || 'none';
        });

        return maxHeight;
    }

    function setTabContentMinHeight() {
        const maxHeight = calculateMaxTabContentHeight();
        const tabContentBlocks = document.querySelectorAll('.timeline-scroll__block-tab-content');
        
        tabContentBlocks.forEach(block => {
            block.style.minHeight = `${maxHeight}px`;
        });
    }

    function openTab(evt, tabName) {
        const tabContents = document.querySelectorAll(".timeline-scroll__block-tab-content");
        const tabLinks = document.querySelectorAll(".timeline-scroll__block-tab-link");
        const targetTab = document.getElementById(tabName);
        
        tabLinks.forEach(link => link.classList.remove("active"));
        tabContents.forEach(tab => {
            tab.classList.remove("active");
            tab.style.display = "none";
        });
        
        evt.currentTarget.classList.add("active");
        
        if (targetTab) {
            targetTab.style.display = "block";
            setTimeout(() => {
                targetTab.classList.add("active");
            }, 10);
        }
    }
    
    function initializeTabs() {
        const tabBlocks = document.querySelectorAll('.timeline-scroll__block-tab');
        
        tabBlocks.forEach(tabBlock => {
            const firstTabContent = tabBlock.parentElement.querySelector(".timeline-scroll__block-tab-content");
            const firstTabLink = tabBlock.querySelector(".timeline-scroll__block-tab-link");
            
            if (firstTabContent && firstTabLink) {
                firstTabContent.style.display = "block";
                firstTabLink.classList.add("active");
                firstTabContent.classList.add("active");
            }
        });
    }

    setTabContentMinHeight();

    initializeTabs();

    window.timelineScrollInstance = {
        setTabContentMinHeight: setTabContentMinHeight
    };

    window.openTab = openTab;

    function isElementAtCenter(element) {
        const rect = element.getBoundingClientRect();
        const elementCenterY = rect.top + rect.height / 2;
        return Math.abs(elementCenterY - centerY) < 50;
    }

    function isElementAboveCenter(element) {
        const rect = element.getBoundingClientRect();
        const elementCenterY = rect.top + rect.height / 2;
        return elementCenterY < centerY;
    }

    function handleScroll() {
        timelineBlocks.forEach(block => {
            const blockIcon = block.querySelector('.timeline-scroll__block-icon');
            const blockContent = block.querySelector('.timeline-scroll__block-content');
            const blockImage = block.querySelector('.timeline-scroll__block-image');
            const blockTracker = block.querySelector('.timeline-scroll__block-track');
            const blockTrackLine = block.querySelector('.timeline-scroll__block-track-line');

            const trackRect = blockTracker.getBoundingClientRect();
            const trackTop = trackRect.top;
            const trackHeight = trackRect.height;
            const trackBottom = trackRect.bottom;

            let trackLineHeight = 0;
            
            if (trackTop <= centerY && trackBottom >= centerY) {
                const totalDistance = trackHeight;
                const distanceFromTop = centerY - trackTop;
                const progress = Math.max(0, Math.min(1, distanceFromTop / totalDistance));
                trackLineHeight = progress * 100;
            } else if (trackTop > centerY) {
                trackLineHeight = 0;
            } else if (trackBottom < centerY) {
                trackLineHeight = 100;
            }

            if (blockTrackLine) {
                blockTrackLine.style.height = `${trackLineHeight}%`;
            }

            if (isElementAtCenter(block)) {
                blockIcon.classList.add('timeline-scroll__block-icon--active');
                blockContent.classList.add('timeline-scroll__block-content--active');
                blockImage.classList.add('timeline-scroll__block-image--active');
            } else if (isElementAboveCenter(block)) {
                blockIcon.classList.add('timeline-scroll__block-icon--active');
                blockContent.classList.add('timeline-scroll__block-content--active');
                blockImage.classList.add('timeline-scroll__block-image--active');
            } else {
                blockIcon.classList.remove('timeline-scroll__block-icon--active');
                blockContent.classList.remove('timeline-scroll__block-content--active');
                blockImage.classList.remove('timeline-scroll__block-image--active');
            }
        });
    }

    window.addEventListener('scroll', handleScroll);
    
    handleScroll();
});